import {Component} from '@angular/core';
import {EnvironmentService} from "./core/api/environment.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'web-application';

  private readonly _showBanner

  constructor(environmentService: EnvironmentService) {
    this._showBanner = environmentService.isProduction.then(result => !result);
  }

  get showBanner() {
    return this._showBanner
  }
}
